module.exports = __webpack_public_path__ + "static/stars-e7ec3abdc42f8ce53bd14370a0ba94c1.png";